import { useMutation } from '@tanstack/react-query';
import { PreviewData } from 'routes/Cellar/types';
import { RQAPICallWithData } from 'store/APIClient';

export const useParseCsvForPreview = (
    isNewTable: boolean,
    onSuccess: (data: PreviewData) => void,
    onError: (data: Error) => void,
) =>
    useMutation({
        mutationFn: (file: File) => {
            const data = new FormData();
            data.set('fileName', file.name);
            data.set('fileData', file);
            return RQAPICallWithData<PreviewData>({
                endpoint: `schema/extension/preview/table?isNewTable=${isNewTable}`,
                method: 'POST',
                body: data,
                isNotJson: true,
            });
        },
        onSuccess: (response) => onSuccess(response.content.data),
        onError,
    });
